import { Box, Paper, Stack, useMediaQuery } from "@mui/material";
// import { Unit } from "../../models/redux-models";
import Close from "@mui/icons-material/Close";
import Bed from "@mui/icons-material/HotelOutlined";
import { ReactComponent as BathroomIcon } from "../../assets/icons/bathroom.svg";
import { ReactComponent as AreaIcon } from "../../assets/icons/area.svg";
import { ChevronRight } from "@mui/icons-material";
import { fills } from "../InteractiveFloorplan";
import { status } from "./FloorplanCard";
import { useAppDispatch } from "../../hooks";
import { setStrattoCurrentApartment } from "../../store/todoStratto-actions";

interface Props {
  x: number;
  y: number;
  selectedFloorplan: any;
  clearSelectedFloor: () => void;
  onClick: () => void;
}

const CARD_HEIGHT = 410;

export const FloorplanstrattoCard = ({
  x,
  y,
  selectedFloorplan,
  clearSelectedFloor,
  onClick,
}: Props) => {
  const dispatch = useAppDispatch()
  const options = { style: "currency", currency: "USD" };
  const numberFormat = new Intl.NumberFormat("en-US", options as any);
  const mobile = useMediaQuery("(max-width:1260px)");

  const handleInternalClick = ()=>{
    dispatch(setStrattoCurrentApartment(selectedFloorplan))
    onClick()
  }


  return (
    <Paper
      sx={{
        width: mobile ? "90% !important" : "270px",
        height: mobile ? "fit-content" : "410px",
        position: "absolute",
        zIndex: 2,
        background: "rgba(0, 0, 0, 0.8)",
        opacity: "0,5",
        borderRadius: "10px",
        boxShadow: "0px 1px 2px rgba(138, 138, 138, 0.5)",
        top: mobile
          ? "30px"
          : y + CARD_HEIGHT >= window.screen.height
          ? window.screen.height - CARD_HEIGHT - 250
          : y - 150,
        left: mobile ? "5% !important" : x + 100,
        animation: "fadeIn 0.8s",
      }}>
      <Stack justifyContent="space-between" sx={{ height: "100%" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{
            backgroundColor: fills[selectedFloorplan.status] ?? fills['available'],
            borderTopRightRadius: mobile ? 0 : "10px",
            borderTopLeftRadius: mobile ? 0 : "10px",
            padding: "0px 15px",
          }}
          alignItems="center">
          <Stack direction="row" spacing={2} alignItems="center">
            <h5>{selectedFloorplan.floor_plan_code?.toUpperCase()}</h5>
            <h5>|</h5>
            <h5>{`${selectedFloorplan.full_name} `}</h5>
          </Stack>
          <Box
            sx={{
              "&:hover": {
                color: "white",
              },
            }}>
            <Close
              style={{ cursor: "pointer" }}
              onClick={() => {
                clearSelectedFloor();
              }}
            />
          </Box>
        </Stack>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignContent="start"
          alignItems="center"
          padding="0px 15px">
          <Stack
            direction="row"
            alignItems="center"
            spacing={0}
            alignContent="start">
            <AreaIcon />
            <h6 style={{ color: "white", margin: 0 }}>
              {selectedFloorplan.area} m2
            </h6>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            spacing={0}
            alignContent="start">
            <Bed sx={{ color: "white", width: "15px", height: "15px" }} />
            <h6 style={{ color: "white", margin: 0 }}>
              {selectedFloorplan.bedrooms}
            </h6>
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            spacing={0}
            alignContent="start">
            <BathroomIcon />
            <h6 style={{ color: "white", margin: 0 }}>
              {selectedFloorplan.bathrooms}
            </h6>
          </Stack>
        </Stack>
        <Stack
          alignContent="center"
          justifyContent="center"
          alignItems="center"
          justifyItems="center">
          <img
            src={selectedFloorplan.images?.[0]?.source}
            alt={selectedFloorplan.images?.[0]?.title}
            style={{
              width: "95%",
              height: mobile ? "100%" : 185,
              objectFit: "contain",
              margin: "8px 0px",
            }}
            onClick={onClick}
          />
        </Stack>
        <Stack
          direction="row"
          sx={{ width: "100%", height: "56px", background: "#000000" }}
          justifyContent="space-between"
          alignContent="start"
          alignItems="center">
          <Stack sx={{ paddingLeft: "10px" }}>
            <h5 style={{ color: "white", margin: 0 }}>
              {`${numberFormat.format(selectedFloorplan.price)} MXN`}
            </h5>
            <h6
              style={{
                margin: 0,
                color: fills[selectedFloorplan.status],
              }}>
              {status[selectedFloorplan.status]}
            </h6>
          </Stack>
          <Stack
            alignContent="center"
            alignItems="center"
            justifyItems="center"
            justifyContent="center"
            sx={{
              height: "100%",
              width: "54px",
              background: "#ffffff",
              cursor: "pointer",
              "&:hover": {
                opacity: "0.8",
              },
            }}
            onClick={handleInternalClick}>
            <ChevronRight style={{ color: "black" }} />
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  );
};
